module.exports = __webpack_public_path__ + "mobile/img/img_avatar_default_pic.5bc463c4.png";